module.exports = __webpack_public_path__ + "static/media/mw.55564ea6.svg";